import React from 'react';
import classnames from 'classnames';
import S from './Block.css';

/**
 * React class that renders a block with a set position and width, one of the main visual elements of the ghant chart
 * @property {number} x1 - starting x value of the element
 * @property {number} x2 - ending x value of the element
 * @property {function} onRollover - rollover functionality
 * @property {function} onClick - onClick functionality
 * @property {any} data - added to the rollover and click function callbacks
 * @property {string} className - class to be applied to the element
 * @property {object} style - css properties to be applied to the element
 * @property {node} children - children to be rendered in the element
 */
class Block extends React.Component {
  onMouseEnter = e => {
    const {
      onRollover,
      data
    } = this.props;
    if (onRollover) {
      onRollover({
        data,
        entered: true,
        block: this,
        originalEvent: e
      });
    }
  };
  onMouseLeave = e => {
    const {
      onRollover,
      data
    } = this.props;
    if (onRollover) {
      onRollover({
        data,
        entered: false,
        block: this,
        originalEvent: e
      });
    }
  };
  onClick = e => {
    const {
      onClick,
      data
    } = this.props;
    if (onClick) {
      onClick({
        data,
        block: this,
        originalEvent: e
      });
    }
  };
  render() {
    const {
      blockComponent,
      componentProps,
      x1,
      x2,
      className,
      style,
      children
    } = this.props;
    return /*#__PURE__*/React.createElement(blockComponent || 'div', {
      ...componentProps,
      className: classnames(S.block, className),
      style: {
        left: `${x1}px`,
        width: `${x2 - x1}px`,
        ...style
      },
      onClick: this.onClick,
      onMouseEnter: this.onMouseEnter,
      onMouseLeave: this.onMouseLeave
    }, children);
  }
}
export default Block;